import { Text, Button } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useState } from 'react';
import { signOutApi } from '@dealstack/frontend/shared/dataExchange/services/auth.service';
import { buildLoginPageUrl, redirectTo } from '@dealstack/frontend/shared/redirecting';
import { AUTH_CALLBACK_CODE } from '@dealstack/shared/lib/common/authCallbackCode';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

export const GenericError = () => {
	const search = new URLSearchParams(window.location.search);
	const reference = search.get('reference');
	const code = search.get('code');
	const isNoAccess = code === AUTH_CALLBACK_CODE.NO_ACCESS;
	const isCancelled = code === AUTH_CALLBACK_CODE.CANCELLED;
	const [isSigningOut, setIsSigningOut] = useState(false);

	const onSignOut = async () => {
		setIsSigningOut(true);

		try {
			await signOutApi();
		} finally {
			redirectTo(buildLoginPageUrl());
		}
	};

	return (
		<div className="min-h-screen flex flex-col justify-center relative">
			<div className="absolute left-[120px] top-[19px]">
				<svg
					width="9rem"
					viewBox="0 0 68 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0 6.522v11.283h4.24c3.228 0 5.494-2.12 5.494-5.674 0-3.555-2.266-5.61-5.495-5.61H0zm7.288 5.609c0 1.973-.88 3.603-2.788 3.603H2.397V8.592H4.5c1.908 0 2.788 1.615 2.788 3.539zM17.876 14.316s.114-.457.114-1.126c0-2.233-1.467-3.799-3.669-3.799-2.217 0-3.93 1.63-3.93 4.305 0 2.707 1.68 4.304 3.98 4.304 1.711 0 2.95-.913 3.521-1.956l-1.94-1.093c-.13.783-.718 1.354-1.582 1.354-.962 0-1.712-.652-1.81-1.99h5.316zm-3.555-3.261c.897 0 1.533.733 1.533 1.728h-3.245c.18-1.125.864-1.728 1.712-1.728zM22.269 11.152c.668 0 1.174.36 1.174.897 0 .57-.636.718-1.761.962-1.321.261-3.017.734-3.017 2.576 0 1.517 1.142 2.413 2.593 2.413 1.255 0 2.005-.717 2.331-1.222h.05c.097.39.195.652.456 1.027h1.728c-.163-.62-.195-1.207-.195-2.07v-3.278c0-2.055-1.468-3.066-3.327-3.066-1.826 0-3.244.946-3.88 2.316l2.021 1.076c.229-.978.881-1.63 1.827-1.63zm1.239 3.555c0 1.01-.734 1.565-1.55 1.565-.716 0-1.075-.342-1.075-.848 0-.652.636-.831 1.337-1.01.62-.164 1.06-.343 1.288-.636v.929zM27.006 17.805h2.315V6h-2.316v11.805zM34.226 16.321c-1.092 0-1.81-.669-2.07-1.565L30.15 15.88C30.82 17.185 32.335 18 34.26 18c1.777 0 3.31-.979 3.31-2.626 0-1.5-1.174-2.087-2.462-2.494-1.223-.392-2.3-.457-2.3-1.076 0-.473.49-.734 1.077-.734.897 0 1.516.57 1.712 1.304l1.973-1.108c-.636-1.093-2.136-1.876-3.767-1.876-1.76 0-3.244.979-3.244 2.528 0 1.565 1.549 2.185 2.788 2.51 1.06.294 1.973.44 1.973 1.093 0 .522-.457.799-1.093.799zM42.557 15.62c-.098.212-.294.522-.636.522-.375 0-.57-.212-.57-.848v-3.946h1.858v-1.76H41.35V6.651l-2.282 1.272v1.663h-1.321v1.761h1.32v4.174c0 1.745.93 2.478 2.365 2.478.945 0 1.712-.456 1.989-.717l-.864-1.663zM47.483 11.152c.668 0 1.174.36 1.174.897 0 .57-.636.718-1.761.962-1.32.261-3.017.734-3.017 2.576 0 1.517 1.142 2.413 2.593 2.413 1.255 0 2.005-.717 2.332-1.222h.049c.097.39.195.652.456 1.027h1.728c-.163-.62-.195-1.207-.195-2.07v-3.278c0-2.055-1.468-3.066-3.326-3.066-1.827 0-3.245.946-3.881 2.316l2.022 1.076c.228-.978.88-1.63 1.826-1.63zm1.24 3.555c0 1.01-.735 1.565-1.55 1.565-.717 0-1.076-.342-1.076-.848 0-.652.636-.831 1.337-1.01.62-.164 1.06-.343 1.288-.636v.929zM55.709 11.152c1.01 0 1.435.897 1.435 1.99l2.103-1.077c-.26-1.32-1.5-2.674-3.538-2.674-2.25 0-3.913 1.63-3.913 4.305 0 2.674 1.663 4.304 3.913 4.304 2.038 0 3.277-1.353 3.538-2.674l-2.103-1.076c0 1.093-.424 1.99-1.435 1.99-1.109 0-1.582-1.077-1.582-2.544s.473-2.544 1.582-2.544zM67.755 9.587h-2.69l-1.76 2.348a27.081 27.081 0 0 0-.995 1.533h-.05s.115-1.011.115-2.022V6h-2.3v11.805h2.3v-1.908l1.092-1.386 2.022 3.294H68l-3.016-4.957 2.771-3.26z"
						fill="#000"
					/>
				</svg>
			</div>
			<div className="flex flex-col items-center">
				<Text c="dark.6" fw={700} style={{ fontSize: '58px', lineHeight: '72px' }}>
					{isNoAccess && 'No access to DealStack'}
					{isCancelled && 'Sign-in cancelled'}
					{!isNoAccess && !isCancelled && 'Unexpected Error'}
				</Text>
				<Text size="B4Medium" c="dark.0" style={{ maxWidth: '768px', marginTop: '24px' }}>
					{isNoAccess &&
						'Your sign-in worked, but this account has no access here. Ask your administrator to grant this account access, or contact our support team if you believe this is a mistake.'}
					{isCancelled &&
						'You closed the sign-in before it finished, so nothing was changed. Use "Go back" to try again.'}
					{!isNoAccess &&
						!isCancelled &&
						"We're sorry, but an unexpected error occurred while processing your request. Please try again later or reach out to our support team for further assistance."}
				</Text>
				{reference && (
					<Text size="B5Medium" c="dark.0" style={{ marginTop: '16px' }}>
						Reference: {reference}
					</Text>
				)}
				<div className="flex flex-row gap-3 mt-12">
					{/* Retrying is futile under NO_ACCESS: it re-authenticates silently against the
					surviving AuthKit session and returns here. */}
					{!isNoAccess && (
						<Button
							type="button"
							variant="secondary"
							size="lg"
							style={{ padding: '8px 16px 8px 16px', height: '48px' }}
							styles={{
								inner: {
									gap: '8px',
								},
							}}
							leftSection={<IconArrowLeft />}
							onClick={() => redirectTo(buildLoginPageUrl())}
						>
							Go back
						</Button>
					)}
					<Button
						type="button"
						variant="secondary"
						size="lg"
						style={{ padding: '8px 16px 8px 16px', height: '48px' }}
						loading={isSigningOut}
						data-testid={TEST_ELEMENT_IDS.GENERIC_ERROR_SIGN_OUT_BUTTON}
						onClick={onSignOut}
					>
						Sign out
					</Button>
					<a href="mailto:support@dealstack.io">
						<Button
							type="button"
							variant="primary"
							size="lg"
							style={{ padding: '8px 16px 8px 16px', height: '48px' }}
						>
							Contact support
						</Button>
					</a>
				</div>
			</div>
		</div>
	);
};
